const blogsSDK={
  serverHost:'/src/assets',//开发基地址地址
  // serverHost:'/resData',//线上基地址
};

export {blogsSDK}



// WEBPACK FOOTER //
// ./src/assets/js/blogsSDK.js